export default [
    {
        component: () => import(/* webpackChunkName: 'exame-laboratorial-jornada-bloqueio' */ '@/views/exame-laboratorial/jornada-bloqueio/Index'),
        path: 'jornada-bloqueio',
        redirect: 'jornada-bloqueio/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'exame-laboratorial-jornada-bloqueio' */'@/views/exame-laboratorial/jornada-bloqueio/List.vue'),
                name: 'exame-laboratorial-jornada-bloqueio-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'exame-laboratorial-jornada-bloqueio' */ '@/views/exame-laboratorial/jornada-bloqueio/Form.vue'),
                name: 'exame-laboratorial-jornada-bloqueio-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'exame-laboratorial-jornada-bloqueio' */ '@/views/exame-laboratorial/jornada-bloqueio/Form.vue'),
                name: 'exame-laboratorial-jornada-bloqueio-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]